import { initStripePaymentButton } from './stripe-pay-button';
import { buildPaymentInitializationPayload, getPaymentInitialization } from './payments/payment-initialization';
import store from './store';
import { fetcher } from './fetcher';
import { getValidPromoCode } from './payments/promo-validity-handler';
import { getDiscountFlow } from './payments/discount-flow';
import { processFreePayment } from './payments/free-payment-transaction';

const provider = 'stripe';

export const getPlan = (planProvider = null) => {
  const id = planProvider ? planProvider + '-plan' : 'stripe-plan';
  const plan = document.getElementById(id);

  if (plan !== null) {
    return plan.value;
  }

  return false;
};

export const getPrice = () => {
  const price = document.getElementById('price');

  if (price !== null) {
    return price.value;
  }

  return false;
};

export const generatePaymentIntentData = provider => {
  return {
    purchasable_id: window.getUuid(),
    checkoutOffer: backEndVars.checkoutOffer,
    type: backEndVars.type,
    provider,
    promoCode: getValidPromoCode(),
    discountFlow: getDiscountFlow(),
  };
};

export const getPageSlug = () => {
  return location.href.substring(location.href.lastIndexOf('/') + 1).replace(/(\?|#)(.*)/, '');
};

export const showLoaderButton = provider => {
  payments.btnLoader.show(provider);
  payments.payButton.disable();
  payments.paymentFormCloseButton.hide();
  payments.formLoader.show();
};

const initStripeElements = () => {
  const stripe = Stripe(window.backEndVars.stripe.token || window.backEndVars.stripe.elements.token);
  const elements = stripe.elements({});

  const style = {
    base: {
      fontSmoothing: 'antialiased',
      fontSize: '20px',
    },
  };

  const classes = {
    base: 'a-input__input',
    focus: 'a-input__input--focus',
    invalid: 'a-input__input--error',
  };

  // Create an instance of the card Element.
  const card = elements.create('cardNumber', { style, classes });
  const expiry = elements.create('cardExpiry', { style, classes });
  const cvc = elements.create('cardCvc', { style, classes });

  // Add an instance of the card Element into the `card-element` <div>.
  card.mount('#stripe-card-number');
  expiry.mount('#stripe-card-date');
  cvc.mount('#stripe-card-cvv');

  card.addEventListener('change', ({ error }) => {
    if (error) {
      payments.formError.display(provider, error.message);
    } else {
      payments.formError.clear(provider);
    }
  });

  // Create a token or display an error when the form is submitted.
  document.querySelector('#stripe-form').addEventListener('submit', event => {
    event.preventDefault();

    showLoaderButton(provider);

    getPaymentInitialization(buildPaymentInitializationPayload({ provider: provider })).then(response => {
      stripe
        .confirmCardPayment(response.clientSecret, {
          payment_method: {
            card: card,
          },
        })
        .then(result => confirmCardPaymentCb(result, provider, window));
    });
  });
};

export const confirmCardPaymentCb = (result, provider, window) => {
  if (result.error) {
    if (result.error.code === 'payment_intent_authentication_failure') {
      payments.formError.display(provider, window.backEndVars.stripe.intent.errorMessage);
    } else {
      payments.formError.display(provider, result.error.message);
    }
    payments.payButton.enable();
    payments.btnLoader.hide(provider);
    payments.paymentFormCloseButton.show();
    payments.formLoader.hide();
  } else {
    payments.checkPaymentStatusAndRedirect(provider, new Url().build('products', window.getUuid(), 'is-paid'), {
      pageSlug: getPageSlug(),
      checkoutOffer: backEndVars.checkoutOffer,
    });
  }
};

const initStripeIntent = () => {
  const stripe = Stripe(window.backEndVars.stripe.intent.token);
  const elements = stripe.elements({});

  const style = {
    base: {
      fontSmoothing: 'antialiased',
      fontSize: '20px',
    },
  };

  const classes = {
    base: 'a-input__input',
    focus: 'a-input__input--focus',
    invalid: 'a-input__input--error',
  };

  // Create an instance of the card Element.
  const card = elements.create('cardNumber', { style, classes });
  const expiry = elements.create('cardExpiry', { style, classes });
  const cvc = elements.create('cardCvc', { style, classes });

  // Add an instance of the card Element into the `card-element` <div>.
  card.mount('#stripe-card-number');
  expiry.mount('#stripe-card-date');
  cvc.mount('#stripe-card-cvv');

  card.addEventListener('change', ({ error }) => {
    if (error) {
      payments.formError.display(provider, error.message);
    } else {
      payments.formError.clear(provider);
    }
  });

  // Create a token or display an error when the form is submitted.
  document.querySelector('#stripe-form').addEventListener('submit', event => {
    event.preventDefault();

    showLoaderButton(provider);

    getPaymentInitialization(buildPaymentInitializationPayload({ provider: provider })).then(response => {
      stripe
        .confirmCardPayment(response.clientSecret, {
          payment_method: {
            card: card,
          },
        })
        .then(result => confirmCardPaymentCb(result, provider, window));
    });
  });
};

export const startUpsalePaymentProcessStripe = data => {
  const stripe = Stripe(window.backEndVars.stripe.intent.token || window.backEndVars.stripe.elements.token);

  getPaymentInitialization(buildPaymentInitializationPayload({ provider: provider, uuid: data.uuid })).then(
    response => {
      // Handle free product
      let paymentDetails =
        backEndVars.boxSequence !== undefined
          ? backEndVars.paymentDetails[backEndVars.boxSequence]
          : backEndVars.paymentDetails;

      let isFreePlan = window.searchAdditionsDetailsByProvider(paymentDetails.planDetails, provider).isFreePlan;

      if (isFreePlan) {
        processFreePayment(paymentDetails, provider);
        confirmCardPaymentCb(response, provider, window);
      } else {
        stripe.confirmCardPayment(response.clientSecret).then(result => confirmCardPaymentCb(result, provider, window));
      }
    },
  );
};

export const prepareDietForPayment = provider => {
  const data = {
    paymentMethod: provider,
    status: 'paymentMethodSelectedAfterPersonalDataInserted',
    customerUuid: window.getCustomerUuid(),
    uuid: window.getAnswersData('uuid'),
    utmParams: store.getMarketingInfo('lastUtmParams'),
  };

  const planProvider = provider.indexOf('paypal') > -1 ? 'paypal' : null;

  const plan = getPlan(planProvider);
  const price = getPrice();

  if (plan && price) {
    data.subscriptionPlan = plan;
    data.price = price;
  }

  if (!data.purchasableType) {
    data.purchasableType = backEndVars.purchasableType;
  }

  if (!data.purchasableCategory) {
    data.purchasableCategory = backEndVars.purchasableCategory;
  }

  const url = new Url().build('products/contact-info/fill/email-first');
  fetcher.put(url, data).then(({ uuid }) => {
    window.setUUID(uuid);
  });
};

export const initStripe = () => {
  document.addEventListener('DOMContentLoaded', () => {
    if (window.backEndVars.stripe.elements.token) {
      initStripeElements();
    }

    if (window.backEndVars.stripe.intent.token) {
      initStripeIntent();
    }

    if (document.querySelector('#payment-request-button')) {
      const stripePayButtonVars = window.backEndVars.paymentTypes['stripe-pay-button'];
      const uuid = window.getAnswersData('uuid');

      initStripePaymentButton(stripePayButtonVars, uuid);
    }
  });
};

window.initStripe = initStripe;
